// 実行時の設定。値は Vite が .env.local からビルド時に埋め込む（秘密は置かない）
function need(name: string, v: string | undefined): string {
  if (!v) throw new Error(`${name} が未設定（app/.env.example を見て .env.local を作る）`);
  return v;
}

export const config = {
  supabaseUrl: need('VITE_SUPABASE_URL', import.meta.env.VITE_SUPABASE_URL),
  anonKey: need('VITE_SUPABASE_ANON_KEY', import.meta.env.VITE_SUPABASE_ANON_KEY),
  eventId: need('VITE_EVENT_ID', import.meta.env.VITE_EVENT_ID),
  tileUrl: import.meta.env.VITE_TILE_URL || 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
  // 位置の上書きは開発サーバーでだけ有効。本番ビルドでは DEV が false になり、コードごと消える
  devGeo: import.meta.env.DEV && import.meta.env.VITE_DEV_GEO === '1',
  photoBucket: 'waggle-photos',
  pollMs: 20_000,
} as const;
